 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {useMutation,} from 'react-relay'

import useAtmosphere from '../hooks/useAtmosphere'

graphql`
  fragment useShareTopicMutation_meeting on ShareTopicSuccess {
    meeting {
      name
      id
    }
  }
`

const mutation = graphql`
  mutation useShareTopicMutation($stageId: ID!, $meetingId: ID!, $channelId: ID!) {
    shareTopic(stageId: $stageId, meetingId: $meetingId, channelId: $channelId) {
      ... on ErrorPayload {
        error {
          message
        }
      }
      ...useShareTopicMutation_meeting @relay(mask: false)
    }
  }
`




const useShareTopicMutation = () => {
  const [commit, submitting] = useMutation(mutation)
  const atmosphere = useAtmosphere()
  const execute = (
    config,
    handlers
  ) => {
    return commit({
      onCompleted: (res) => {
        const error = res.shareTopic.error
        if (!error) {
          _optionalChain([handlers, 'optionalAccess', _ => _.onSuccess]) && handlers.onSuccess()
        } else {
          atmosphere.eventEmitter.emit('addSnackbar', {
            message: error.message,
            autoDismiss: 5,
            key: 'shareTopicError'
          })
          _optionalChain([handlers, 'optionalAccess', _2 => _2.onError]) && handlers.onError()
        }
      },
      // allow components to override default handlers
      ...config
    })
  }
  return [execute, submitting] 
}

export default useShareTopicMutation
